import { useEffect } from "react";

function DialogBox({ show, onClose, type }) {
  useEffect(() => {
    if (show) {
      const timer = setTimeout(() => {
        onClose();
      }, 2000);

      return () => clearTimeout(timer);
    }
  }, [show, onClose]);

  if (!show) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div
        className={`bg-white p-4 sm:p-6 rounded-lg shadow-lg text-center w-full max-w-[90vw] sm:max-w-md md:max-w-lg mx-auto border-t-4${
          type === "Success" ? "border-green-500" : "border-red-500"
        }`}
      >
        <div className="flex flex-col items-center">
          <h2
            className={`text-base sm:text-lg md:text-xl font-bold mt-2 ${
              type === "Success" ? "text-green-600" : "text-red-600"
            }`}
          >
            {type === "Success" ? "SUCCESS" : "ERROR!"}
          </h2>
          <p className="text-gray-700 font-semibold mt-2">
            {type === "Success"
              ? "Form Submitted Successfully"
              : "Error Submitting Form"}
          </p>
          <p className="text-gray-500 text-sm mt-1">
            {type === "Success"
              ? "We Will Shortly Contact You!"
              : "Please Try Again!"}
          </p>
          <button
            onClick={onClose}
            className={`px-3 py-1.5 sm:px-4 sm:py-2 mt-4 rounded-lg transition font-semibold text-sm sm:text-base ${
              type === "Success"
                ? "bg-green-500 hover:bg-green-600"
                : "bg-red-500 hover:bg-red-600"
            } text-white`}
          >
            {"Continue"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default DialogBox;
